<template>
  <div id="app"> <!-- Único elemento raiz -->
    <navbar class="mb-5"/>
    <progress
        v-if="AppStoreStore.loading"
        class="progress is-primary is-small mt-6"
        max="100"
    ></progress>

    <!-- Container principal que engloba colunas e conteúdo mobile -->
    <div> 
      <div class="columns is-mobile">
        <!-- Coluna Principal (Conteúdo) -->
        <div
            class="column"
            :class="{
              'is-8-desktop': isDesktop && AppStoreStore.openReviewSideBar,
              'is-12': !isDesktop || !AppStoreStore.openReviewSideBar,
              'is-12-tablet': true,
              'is-12-mobile': true
            }"
        >
          <div class="container wizard-container">
            <wizard ref="wizard" :formData="formData" />
          </div>
        </div>

        <!-- Sidebar Original (Coluna - Apenas Desktop/Tablet) -->
        <div 
          class="column is-4-desktop sidebar-container is-hidden-mobile" 
          v-if="AppStoreStore.openReviewSideBar" 
        >
          <review-sidebar @nextTab="nextTab" :formData="formData" :isInline="false"></review-sidebar> <!-- isInline=false explícito -->
        </div>
      </div>

      <!-- Resumo Inline (Apenas Mobile) - Sempre visível -->
      <div class="container is-hidden-tablet mobile-container" v-if="AppStoreStore.openReviewSideBar"> 
        <!-- Container do Resumo Inline (Mobile) - Sempre visível -->
        <div class="mobile-summary-container">
          <!-- Passando a prop isInline=true para o modo mobile -->
          <review-sidebar @nextTab="nextTab" :formData="formData" :isInline="true"></review-sidebar>
        </div>
      </div>
    </div> <!-- Fim do container principal -->

  </div> <!-- Fim do único elemento raiz -->
</template>

<script>
import Wizard from "@/components/Wizard/Index";
import Navbar from "@/components/Wizard/Navbar";
import { mapStores } from 'pinia'

import { useAppStore } from "@/stores/AppStore";
import ReviewSidebar from "@/components/Wizard/ReviewSidebar/Index";
import notificationsApi from "@/apis/notifications";
import { Alphabet, CiphertrustClient } from '@funcional/crypto-client';

export default {
  name: 'app',

  components: {
    Wizard,
    Navbar,
    ReviewSidebar
  },

  data() {
    return {
      isDesktop: window.innerWidth >= 1024, // Bulma's desktop breakpoint
      formData: {
        integration: {
          showStep: true,
          data: {
            type: null
          },
          hasSum: false,
        },
        partner: {
          showStep: true,
          data: {},
          hasSum: true
        },
        plan: {
          showStep: true,
          unit: 'mês',
          data: {},
          hasSum: true
        },
        messagePacket: {
          showStep: true,
          data: {},
          hasSum: true,
          isApiCloud: false
        },
        extraAccesses: {
          showStep: false,
          data: {},
          hasSum: true,
          unit: 'mês'
        },
        extraChips: {
          showStep: false,
          data: {},
          hasSum: true,
          unit: 'mês'
        },
        orderManagement: {
          showStep: false,
          data: {},
          hasSum: true,
          unit: 'mês'
        },
        recoverBannedChip: {
          showStep: false,
          data: {},
          hasSum: true,
          unit: 'mês'
        },
        extraServices: {
          showStep: false,
          data: [],
          hasSum: true
        },
        technicalManager: {
          showStep: false,
          data: {},
          hasSum: false
        },
        recommender: {
          showStep: false,
          data: {},
          hasSum: false
        },
        legalGuardian: {
          showStep: false,
          data: {},
          hasSum: false
        },
        company: {
          showStep: false,
          data: {},
          hasSum: false
        },
        customer: {
          showStep: false,
          data: {},
          hasSum: false
        }
      }
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Initial check

    // Sempre mostrar o resumo no mobile
    if (!this.isDesktop) {
      this.AppStoreStore.isMobileSidebarVisible = true;
    }

    const queryData = this.$route.query
    console.log(queryData);
    if (queryData.idExterno !== undefined) {
      // Company Data
      this.formData.company.data.network_id = queryData.id_rede;
      this.formData.company.data.external_id = queryData.idExterno;
      this.formData.company.data.flag_name = queryData.bandeira_nome;
      this.formData.company.data.neighbourhood = queryData.loja_bairro;
      this.formData.company.data.zipcode = queryData.loja_cep;
      this.formData.company.data.city = queryData.loja_cidade;
      this.formData.company.data.state = queryData.loja_uf;
      this.formData.company.data.cnpj_document = queryData.loja_cnpj;
      this.formData.company.data.additional_details = queryData.loja_complemento;
      this.formData.company.data.street = queryData.loja_endereco;
      this.formData.company.data.fantasy_name = queryData.loja_nome_fantasia;
      this.formData.company.data.number = queryData.loja_numero;
      this.formData.company.data.social_reason = queryData.loja_razao_social;

      // Legal Guardian Data
      this.formData.legalGuardian.data.cpf_document = this.decryptRequest(queryData.usuario_cpf);
      this.formData.legalGuardian.data.email = this.decryptRequest(queryData.usuario_email);
      this.formData.legalGuardian.data.name = this.decryptRequest(queryData.usuario_nome);
      this.formData.legalGuardian.data.phone_number = this.decryptRequest(queryData.usuario_telefone);
      this.formData.legalGuardian.data.rg_document = this.decryptRequest(queryData.usuario_rg);

      notificationsApi.send({
        external_id: queryData.idExterno,
        status: 'INICIADA'
      })
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    nextTab() {
      this.$refs.wizard.nextTab()
    },
    async decryptRequest(value) {
      try {
        return await CiphertrustClient.decrypt(value, Alphabet.ALPHANUMERIC);
      } catch (error) {
        throw new Error(error);
      }
    },
    handleResize() {
      this.isDesktop = window.innerWidth >= 1024;
      
      // Se não for desktop, sempre mostrar o resumo
      if (!this.isDesktop) {
        this.AppStoreStore.isMobileSidebarVisible = true;
      }
    }
  },

  computed: {
    ...mapStores(useAppStore)
  }
}
</script>

<style lang="scss">
$tablet: 769px;
$desktop: 1024px;

.container {
  padding: 15px; // Padding menor para mobile e tablet
  
  @media screen and (min-width: $desktop) {
    padding: 40px; /* Padding original para desktop */
  }
}

/* Estilos para a sidebar original (coluna desktop/tablet) */
.sidebar-container.is-hidden-mobile {
  /* Estilos específicos para a sidebar em coluna, se necessário */
  /* Ex: padding-top: 0; */
}

/* Estilos para o wizard em telas pequenas */
.wizard-container {
  @media screen and (max-width: ($tablet - 1px)) {
    overflow-x: auto; /* Permite rolagem horizontal se necessário */
  }
}

/* Estilos para o container de resumo mobile */
.mobile-container {
  margin-top: 1rem;
}

/* Estilos para o resumo inline (Mobile) */
.mobile-summary-container {
  border: 1px solid #dbdbdb; // Borda cinza claro
  border-radius: 6px;      // Bordas arredondadas
  padding: 1rem;           // Espaçamento interno
  background-color: #ffffff; // Fundo branco
  margin-bottom: 1rem;     // Margem inferior
}

[v-cloak] { display: none; }
</style>
